import { IconComponentType } from '../../Icon.types'

export const YellowStar: IconComponentType = ({ size = 24, color = '#FFC672', className = '', ariaLabel }) => (
	<svg
		width={size}
		height={size}
		viewBox={`0 0 ${size} ${size}`}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		className={className}
	>
		<g id="24/dark/star">
			<path
				id="Vector"
				d="M12.9637 3L15.888 8.92429L22.4274 9.88013L17.6956 14.489L18.8123 21L12.9637 17.9243L7.11514 21L8.23186 14.489L3.5 9.88013L10.0394 8.92429L12.9637 3Z"
				fill={color}
			/>
		</g>
	</svg>
)
